import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-important-disclosures',
  templateUrl: './important-disclosures.component.html',
  imports: [RouterModule]
})
export class ImportantDisclosuresComponent {
}
